import {
  formatDate,
  utcToZonedTime,
  de,
  addMinutes,
  PRODUCT_ONLINE_EVENT_TAXON_ID,
  fromUnixTime,
  isPast,
  intervalToDuration,
  formatDuration
} from '@/resources/helpers';
import type { Event } from '@/resources/types';
import { venueGetters } from '../getters/index';
import { useAppConfig } from '#imports';

export function getFormattedDate(date: Date, dateFormat: string, timeZone: string): string {
  return formatDate(utcToZonedTime(date, timeZone), dateFormat, { locale: de, timeZone });
}

export function getFormattedStartEndTime(date: Date, duration: number, timeZone: string, format: string = 'k:mm') {
  const zonedTime = utcToZonedTime(date, timeZone);

  return {
    start_time: formatDate(zonedTime, format, { locale: de, timeZone }),
    end_time: formatDate(addMinutes(zonedTime, duration), format, { locale: de, timeZone })
  };
}

export function getMetaData(product: Event, ctx: any) {
  const config = useAppConfig();
  let title = config.seo.titleFormat.replace('{title}', product?.title);
  let description = 'in prodict ts';

  if (product.eventTimestamp > 0) {
    const unixDate = fromUnixTime(product.eventTimestamp);
    const date = getFormattedDate(unixDate, 'dd.MM.yyyy', config.timeZone);
    const time = getFormattedStartEndTime(unixDate, product.duration, config.timeZone).start_time;

    if (product.main_taxon_id === PRODUCT_ONLINE_EVENT_TAXON_ID) {
      title = ctx.t('events.seo_online_title', {
        title: product?.title,
        date
      });
      description = ctx.t('events.seo_online_description', {
        title: product?.title,
        host: product.hostName,
        date,
        time
      });
    } else {
      title = ctx.t('events.seo_title', {
        title: product?.title,
        venue: product.venueName,
        date
      });
      description = ctx.t('events.seo_description', {
        title: product?.title,
        venue: product.venueName,
        host: product.hostName,
        city: product.cityName,
        date,
        time
      });
    }
  }

  return {
    title,
    description
  };
}

export function isProductDisabled(product: Event) {
  // return true;
  if (product) {
    const salesCloseDate = fromUnixTime(product.salesCloseTimestamp);

    return product.quantity <= 0 || isPast(salesCloseDate);
  }
  return false;
}

export function isProductSoldOut(product: Event) {
  // return true;
  if (product) {
    return product.quantity <= 0;
  }
  return true;
}

export function isProductSalesClosed(product: Event) {
  // return true;

  if (product) {
    const salesCloseDate = fromUnixTime(product.salesCloseTimestamp);

    return isPast(salesCloseDate);
  }
  return true;
}

export function getDaysUntilEvent(date: number | string, isTimeStamp: boolean = true) {
  let duration = intervalToDuration({
    start: new Date(),
    end: isTimeStamp && typeof date === 'number' ? fromUnixTime(date) : new Date(date)
  });

  formatDuration(duration, {
    delimiter: ', '
  });
  return duration;
}
